<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <b-alert
          variant="primary"
          :show="errorMessage !== ''"
        >
          <div class="alert-body">
            {{ errorMessage }}
          </div>
        </b-alert>
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >
          <!-- Form -->
          <b-form
            class=""
            @submit.prevent="handleSubmit(onSubmit)"
          >
            <!-- old password -->
            <validation-provider
              #default="validationContext"
              :name="$t('Old Password')"
              rules="required|min:4|max:50"
            >
              <b-form-group
                :label="$t('Old Password')"
                label-for="old-password"
              >
                <b-form-input
                  id="old-password"
                  v-model="passwordOld"
                  :state="getValidationState(validationContext)"
                  type="password"
                  autocomplete="off"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!--/ old password -->

            <!-- password -->
            <validation-provider
              #default="validationContext"
              name="password"
              rules="required|min:4|max:50"
            >
              <b-form-group
                :label="$t('New Password')"
                label-for="new-password"
              >
                <b-form-input
                  id="new-password"
                  v-model="password"
                  :state="getValidationState(validationContext)"
                  type="password"
                  autocomplete="off"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- confirm password -->
            <validation-provider
              #default="validationContext"
              name="confirm_password"
              rules="required|confirmed:password"
            >
              <b-form-group
                :label="$t('Confirm Password')"
                label-for="confirm-password"
              >
                <b-form-input
                  id="confirm-password"
                  v-model="confirmPassword"
                  type="password"
                  autocomplete="off"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <!--/ retype password -->

            <!-- buttons -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mt-1 mr-1"
              :disabled="loading"
            >
              {{ $t('Save changes') }}
            </b-button>
            <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            class="mt-1"
          >
            Reset
          </b-button> -->
          </b-form>

        </validation-observer>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import formValidation from '@core/comp-functions/forms/form-validation'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, confirmed, mediumPassword, alphaNum,
} from '@validations';
import { showToast } from '@/@core/utils/utils'
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BCard, BAlert,
  BInputGroup, BFormInvalidFeedback,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import store from '@/store'
import useAccount from './useAccount'

export default {
  components: {
    BInputGroup,
    BAlert,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BCard,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: ['userData'],
  data() {
    return {
      required,
      confirmed,
      mediumPassword,
      alphaNum,
    }
  },
  setup() {
    const passwordOld = ref('')
    const password = ref('')
    const confirmPassword = ref('')
    const errorMessage = ref('')

    const { loading, statusOptions, genderOptions } = useAccount();

    const blankData = {
      passwordOld: '',
      password: '',
      confirmPassword: '',
    }

    const resetData = () => {
      passwordOld.value = blankData.passwordOld;
      password.value = blankData.password;
      confirmPassword.value = blankData.confirmPassword;
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    const onSubmit = () => {
      store.dispatch('account/updateAccount', {
        password_old: passwordOld.value,
        password: password.value,
        confirm_password: confirmPassword.value,
        update_type: 'password',
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.code === 200) {
              resetForm();
              errorMessage.value = '';
              showToast(response.data.message, { variant: 'success' })
            } else {
              showToast(response.data.message)
              errorMessage.value = response.data.message
            }
          } else {
            errorMessage.value = response.message
          }
        })
    }
    return {
      loading,
      errorMessage,
      passwordOld,
      confirmPassword,
      password,
      onSubmit,
      refFormObserver,
      getValidationState,
      statusOptions,
      genderOptions,
    }
  },
  methods: {
  },
}
</script>
